<template>
  <el-button
    @mouseenter="showQc = true"
    @mouseleave="showQc = false"
    class="contact"
    size="large"
    plain
    >在线咨询
  </el-button>

  <img
    v-show="
      (showQc && videoDesc[0]?.maID[0] == 'ma055618') ||
      (showQc && videoDesc[0]?.maID[0] == 'ma025000')
    "
    src="../../src/assets/images/个人微信.jpg"
    alt=""
  />
  <img
    v-show="
      (showQc && videoDesc[0]?.maID[0] == 'ma190727') ||
      (showQc && videoDesc[0]?.maID[0] == 'ma020000')
    "
    src="../../src/assets/images/黄老师7156.jpg"
    alt=""
  />
</template>

<script>
import { ref } from "vue";
export default {
  props: {
    videoDesc: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const showQc = ref(false);
    return { showQc };
  },
};
</script>

<style lang="less" scoped>
img {
  position: absolute;
  width: 180px;
  height: 180px;
  top: -7px;
  right: -12px;
}
</style>
